const initialState = {
  vouchers: null,
  voucherDetails: null,
  pointsList: null,
  doneUserList: null,
  pointDetails: null,
  rewardHistoryList: null,
  rewardHistoryDetails: null,
  loading: false,
  error: null,
};

export const rewardsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "START_LOADING":
      return { ...state, loading: true, error: null };

    // Add Reward Voucher (existing)
    case "ADD_REWARD_VOUCHER_REQUEST":
      return { ...state, loading: true, error: null };
    case "ADD_REWARD_VOUCHER_SUCCESS":
      return { ...state, loading: false, error: null };
    case "ADD_REWARD_VOUCHER_FAILED":
      return { ...state, loading: false, error: action.payload };

    // List Reward Vouchers (existing)
    case "LIST_REWARD_VOUCHERS_REQUEST":
      return { ...state, loading: true, error: null };
    case "LIST_REWARD_VOUCHERS_SUCCESS":
      return {
        ...state,
        loading: false,
        vouchers: action.payload,
        error: null,
      };
    case "LIST_REWARD_VOUCHERS_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
        vouchers: null,
      };

    // View Single Voucher (existing)
    case "VIEW_REWARD_VOUCHER_REQUEST":
      return { ...state, loading: true, error: null };
    case "VIEW_REWARD_VOUCHER_SUCCESS":
      return {
        ...state,
        loading: false,
        voucherDetails: action.payload,
        error: null,
      };
    case "VIEW_REWARD_VOUCHER_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
        voucherDetails: null,
      };

    // Reward points
    case "LIST_REWARD_USER_POINTS_REQUEST":
      return { ...state, loading: true, error: null };
    case "LIST_REWARD_USER_POINTS_SUCCESS":
      return {
        ...state,
        loading: false,
        pointsList: action.payload,
        error: null,
      };
    case "LIST_REWARD_USER_POINTS_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
        pointsList: null,
      };

    case "VIEW_DONE_REWARD_USER_REQUEST":
      return { ...state, loading: true, error: null };
    case "VIEW_DONE_REWARD_USER_SUCCESS":
      return {
        ...state,
        loading: false,
        rewardHistoryDetails: action.payload,
        error: null,
      };
    case "VIEW_DONE_REWARD_USER_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
        rewardHistoryDetails: null,
      };

    // View Single Reward User Point
    case "VIEW_REWARD_POINTS_REQUEST":
      return { ...state, loading: true, error: null };
    case "VIEW_REWARD_POINTS_SUCCESS":
      return {
        ...state,
        loading: false,
        pointDetails: action.payload,
        error: null,
      };
    case "VIEW_REWARD_POINTS_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
        pointDetails: null,
      };

    case "UPDATE_REWARD_POINTS_REQUEST":
      return { ...state, loading: true, error: null };
    case "UPDATE_REWARD_POINTS_SUCCESS":
      return { ...state, loading: false, error: null };
    case "UPDATE_REWARD_POINTS_FAILED":
      return { ...state, loading: false, error: action.payload };


    // Remove Reward User Points
    case "REMOVE_REWARD_USER_POINTS_REQUEST":
      return { ...state, loading: true, error: null };
    case "REMOVE_REWARD_USER_POINTS_SUCCESS":
      return {
        ...state,
        loading: false,
        pointsList: state.pointsList
          ? {
            ...state.pointsList,
            data: state.pointsList.data.filter(
              (item) => item._id !== action.payload
            ),
          }
          : null,
        error: null,
      };
    case "REMOVE_REWARD_USER_POINTS_FAILED":


    // Reward User Request
    case "LIST_REWARD_USER_REQUEST":
      return { ...state, loading: true, error: null };
    case "LIST_REWARD_USER_SUCCESS":
      return {
        ...state,
        loading: false,
        doneUserList: action.payload,
        error: null,
      };
    case "LIST_REWARD_USER_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
        doneUserList: null,
      };

    case "VIEW_REWARD_USER_REQUEST":
      return { ...state, loading: true, error: null };
    case "VIEW_REWARD_USER_SUCCESS":
      return {
        ...state,
        loading: false,
        rewardHistoryDetails: action.payload,
        error: null,
      };
    case "VIEW_REWARD_USER_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
        rewardHistoryDetails: null,
      };

    // Update Reward Voucher (existing)
    case "UPDATE_REWARD_VOUCHER_REQUEST":
      return { ...state, loading: true, error: null };
    case "UPDATE_REWARD_VOUCHER_SUCCESS":
      return { ...state, loading: false, error: null };
    case "UPDATE_REWARD_VOUCHER_FAILED":
      return { ...state, loading: false, error: action.payload };

    // Remove Reward Voucher (existing)
    case "REMOVE_REWARD_VOUCHER_REQUEST":
      return { ...state, loading: true, error: null };
    case "REMOVE_REWARD_VOUCHER_SUCCESS":
      return {
        ...state,
        loading: false,
        vouchers: state.vouchers
          ? {
            ...state.vouchers,
            data: state.vouchers.data.filter(
              (item) => item._id !== action.payload
            ),
          }
          : null,
        error: null,
      };
    case "REMOVE_REWARD_VOUCHER_FAILED":
      return { ...state, loading: false, error: action.payload };

    // New: List Reward History Users
    case "LIST_REWARD_HISTORY_USERS_REQUEST":
      return { ...state, loading: true, error: null };
    case "LIST_REWARD_HISTORY_USERS_SUCCESS":
      return {
        ...state,
        loading: false,
        rewardHistoryList: action.payload,
        error: null,
      };
    case "LIST_REWARD_HISTORY_USERS_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
        rewardHistoryList: null,
      };

    // New: View Single Reward History User
    case "VIEW_REWARD_HISTORY_USER_REQUEST":
      return { ...state, loading: true, error: null };
    case "VIEW_REWARD_HISTORY_USER_SUCCESS":
      return {
        ...state,
        loading: false,
        rewardHistoryDetails: action.payload,
        error: null,
      };
    case "VIEW_REWARD_HISTORY_USER_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
        rewardHistoryDetails: null,
      };

    case "STOP_LOADING":
      return { ...state, loading: false };

    default:
      return state;
  }
};
